import React, { useState, useMemo } from 'react';
import { Container, Col } from "react-bootstrap";
import { StyledKfTable } from '../../../../Styling/styledTable/StyledTable';
// import UseTableSorter from '../../../components/useTable/UseTable';
import usePaginator from '../../../../components/useTable/UsePaginator';
import UseTableSorter from '../../../../components/useTable/UseTable';
import { TableBorder, TitleSectionTables, KredittvurderingForm, KredittvurderingTd, StyledKvTable } from '../../../../Styling/styledKredittvurdering/styledKvComponents';


const TvangEiendomTable = (props) => {

    const localeMessages = props.localeMessages
    const kvState = props.kredittvurderingState;
    const ratingData = props.fetchedRating;

    // State for grid sorting
    const [currentSeq, setCurrentSeq] = useState('up'); // default
    const [currentField, setCurrentField] = useState('documentNumber');    // feltnavn
    const [currentType, setCurrentType] = useState('string'); // num
    const [sortClicked, setSortClicked] = useState(0);

    const [masterT1ChangeSortField, t1GetSortFunc, t1IndicaterIcon] = UseTableSorter(
        currentSeq, setCurrentSeq,
        currentField, setCurrentField,
        currentType, setCurrentType
    )

    // Nødvendig pga henting av memoised felt
    const t1ChangeSortField = (fieldName, fieldType) => {
        masterT1ChangeSortField(fieldName, fieldType)

        // Sett trigger for å tvinge memoized function til rerender
        setSortClicked(Date.now())
    }

    const sortedData = useMemo(
        () => {
            if (ratingData.length > 0) {
                return ratingData.sort(t1GetSortFunc().fn)
            }
            else {
                return []
            }
        },
        [ratingData, sortClicked]
    );

    const formatAmountsCell = (amounts) => amounts.map(a => `${a.amount} ${a.currency}`).join(', ');

    const formatNamesCell = (arr) => arr.map(x => x.name).join(', ');

    // state for grid paginator
    const [numberPrPage, setNumberPerPage] = useState(5)
    const [activePage, setActivePage] = useState(1);

    const [Paginate, PaginationNav, PaginationDropdown, PaginationIndex, resetPagination] = usePaginator(
        sortedData,
        numberPrPage, setNumberPerPage,
        activePage, setActivePage
    )
    
    const printHeader = (t1IndicaterIcon, t1ChangeSortField) => {
      return (
          <thead>
              <tr>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('id', 'string')}>{localeMessages['GH_id']}{t1IndicaterIcon('id')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('legalFoundation', 'string')}>{localeMessages['GH_legalFoundation']}{t1IndicaterIcon('legalFoundation')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('directResponsibility', 'string')}>{localeMessages['GH_directResponsibility']}{t1IndicaterIcon('directResponsibility')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('updatedDate', 'string')}>{localeMessages['GH_updatedDate']}{t1IndicaterIcon('updatedDate')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('registeredDate', 'string')}>{localeMessages['GH_registeredDate']}{t1IndicaterIcon('registeredDate')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('registeredOnMultipleProperties', 'string')}>{localeMessages['GH_registeredOnMultipleProperties']}{t1IndicaterIcon('registeredOnMultipleProperties')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('multipleDefendants', 'string')}>{localeMessages['GH_multipleDefendants']}{t1IndicaterIcon('multipleDefendants')}</th>
                  <th style={{ backgroundColor: 'white' }} >Beløp</th>
                  <th style={{ backgroundColor: 'white' }} >Kravstillere</th>
                  <th style={{ backgroundColor: 'white' }} >Prosessfullmektiger</th>
              </tr>
          </thead>
      )
    }

    const printRow = (model) => {
        return (
            <tr key={model.i}>
               <KredittvurderingTd>{model.id}</KredittvurderingTd>
               <KredittvurderingTd>{model.legalFoundation}</KredittvurderingTd>
               <KredittvurderingTd>{model.directResponsibility}</KredittvurderingTd>
               <KredittvurderingTd>{model.updatedDate}</KredittvurderingTd>
               <KredittvurderingTd>{model.registeredDate}</KredittvurderingTd>
               <KredittvurderingTd>{model.registeredOnMultipleProperties}</KredittvurderingTd>
               <KredittvurderingTd>{model.multipleDefendants}</KredittvurderingTd>
               <KredittvurderingTd>{formatAmountsCell(model.amounts)}</KredittvurderingTd>
               <KredittvurderingTd>{model.claimant.name}</KredittvurderingTd>
               <KredittvurderingTd>{model.processRepresentativeAgent.name}</KredittvurderingTd>
           </tr>
        )
    }

    return (
        <>
            <Container fluid="true">
                <TableBorder>
                    <KredittvurderingForm>
                        <Col xs={12} md={12}>
                            <TitleSectionTables>Tvangsfullbyrdelse av eiendom</TitleSectionTables>
                            <PaginationDropdown />
                            <StyledKvTable>
                                {printHeader(t1IndicaterIcon, t1ChangeSortField)}

                                <tbody>
                                    <Paginate>
                                        {/* paginate forventer en funksjon */}
                                        {row => printRow(row)}
                                    </Paginate>
                                </tbody>
                            </StyledKvTable>
                            <br />
                            <PaginationIndex />
                            <br />
                            <PaginationNav />
                            <br/>
                        </Col>
                    </KredittvurderingForm>
                </TableBorder>            
            </Container>

        </>
    )
}

export default TvangEiendomTable



